/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-05-08 14:10:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-03 18:02:51
 * @FilePath: /src/store/slices/wishSlice.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { StateCreator } from 'zustand';

import { fetchCustomerWish } from '@/api/account';
import { CustomerWishParams } from '@/api/types/account';
import { fetchAddWish, fetchCancelWish } from '@/api/wish';
import { Store } from '@/store';

export interface WishState {
  wishNum: number;
}

export interface WishActions {
  setWishNum: (wishNum: WishState['wishNum']) => void;
  getWish: (payload?: CustomerWishParams) => Promise<any>;
  addToWish: (payload: { product_id: number | number[] }) => Promise<any>;
  cancelToWish: (payload: { product_id: number[] }) => Promise<any>;
  getWishNum: () => number;
}

export type WishSlice = WishState & WishActions;

export const initialWishState: WishState = {
  wishNum: 0,
};

export const createWishSlice: StateCreator<Store, [], [], WishSlice> = (set, get) => ({
  ...initialWishState,
  setWishNum: (wishNum: WishState['wishNum']) => {
    set((state) => ({ ...state, wishNum }));
  },
  getWishNum: () => {
    return get().wishNum;
  },

  /**
   * @description: 获取收藏列表
   */
  getWish: async (payload?: CustomerWishParams) => {
    try {
      const response = await fetchCustomerWish(payload || { page: 1, limit: 1 });
      if (response.code === 200) {
        const { total } = response.data;
        set((state) => ({ ...state, wishNum: total }));
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * @description: 添加心愿单
   */
  addToWish: async (payload: { product_id: number | number[] }) => {
    try {
      const response = await fetchAddWish(payload);
      if (response.code === 200) {
        // 重新获取心愿单数量
        await get().getWish();
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * @description: 移除心愿单
   */
  cancelToWish: async (payload: { product_id: number[] }) => {
    try {
      const response = await fetchCancelWish(payload);
      if (response.code === 200) {
        // 重新获取心愿单数量
        await get().getWish();
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
});
